import React from 'react';
import { ImgRender } from './BFComponents';

const MainBusinesses = () => {
    return (
        <div className="container bg-white">
            <div className="row justify-content-center">
                <div className="col-md-3">
                    <div className="text-center p-2 " height="100%">
                        <a href="/root">
                            <ImgRender image={"canon-logo-red.svg"} width={50} cssClass={"my-2"} />
                            <ImgRender image={"card-printer.jpg"} width={100} />
                        </a>
                                Home printers, office printers, document scanners & more.
                            </div>
                </div>

                <div className="col-md-3">
                    <div className="text-center p-2">
                        <a href="http://www.steelcase.com">
                            <ImgRender image={"steelcase-black.svg"} width={50} cssClass={"my-2"} />
                            <ImgRender image={"bg-chairs.jpg"} width={100} />
                        </a>
                              Chairs, desks, all your small office, home office and corporate furniture needs.  </div>
                </div>

                <div className="col-md-3">
                    <div className="text-center p-2">
                        <h3>Office Supplies</h3>
                        <a href="/static_page/navigator">
                            <ImgRender image={"bg-supplies.jpg"} width={100} />
                            <ImgRender image={"navigator-black.svg"} width={50} cssClass={"d-block"} />
                        </a>
                                Paper, inks, toner & more.
                            </div>
                </div>
            </div>
        </div>
    )
}

export default MainBusinesses;